import MediaMeasurer from './MediaMeasurer';
import { update } from 'Emitter';
import { MEASUREMENT } from 'StateEvents';
import * as VPAIDEvents from 'Enum/VPAIDEvents';

export default class VPAIDMediaMeasurer extends MediaMeasurer {
  constructor() {
    super();
  }

  canMeasurePlayback(state) {
    return state.media.started && state.media.duration > -2;
  }

  thresholdCrossed(mediaState, measurementState, eventNumber) {
    return this.messageReceived(mediaState.received, eventNumber) && !this.eventRecorded(measurementState, eventNumber);
  }

  messageReceived(messageList, eventNumber) {
    return messageList.indexOf(this.playbackVPAIDEventMap[eventNumber]) > -1;
  }

  eventRecorded(record, eventNumber) {
    return record[this.playbackEventMap[eventNumber]];
  }

  get playbackVPAIDEventMap() {
    return {
      0: VPAIDEvents.AD_IMPRESSION,
      1: VPAIDEvents.AD_VIDEO_FIRST_QUARTILE,
      2: VPAIDEvents.AD_VIDEO_MIDPOINT,
      3: VPAIDEvents.AD_VIDEO_THIRD_QUARTILE,
      4: VPAIDEvents.AD_VIDEO_COMPLETE
    }
  }

}


// WEBPACK FOOTER //
// ./src/Services/Measurement/VPAIDMediaMeasurer.js